import React, { ReactNode, createContext, useContext } from "react";

type StorageKeyPrefix = {
  prefix: string;
};
const StorageKeyPrefixContext = createContext<StorageKeyPrefix | null>(null);

export const StorageKeyPrefixProvider = ({
  children,
  prefix,
}: {
  children: ReactNode;
  prefix: string;
}) => {
  return (
    <StorageKeyPrefixContext.Provider value={{ prefix }}>
      {children}
    </StorageKeyPrefixContext.Provider>
  );
};

export const useStorageKeyPrefix = () => {
  const context = useContext(StorageKeyPrefixContext);
  return context?.prefix;
};
